import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { FlaskConical } from "lucide-react";

function LabField({ fu, def, value, unit, onValue, onUnit }) {
  return (
    <div className="mt-2">
      <div className="flex gap-2">
        <Input data-testid={`followup-${fu.id}`} type="number" step="any" value={value} onChange={(e) => onValue(e.target.value)} placeholder="Result" className="flex-1" />
        <Select value={unit || def.canonical} onValueChange={onUnit}>
          <SelectTrigger data-testid={`followup-${fu.id}-unit`} className="w-40"><SelectValue /></SelectTrigger>
          <SelectContent>
            {def.units.map((u) => <SelectItem key={u} value={u} data-testid={`followup-${fu.id}-unit-${u}`}>{u}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
      <p className="text-[11px] text-slate-500 mt-1">Reference range: {def.ref_range} · <span className="font-semibold text-amber-700">Confirm the unit matches the lab report</span></p>
    </div>
  );
}

export function FollowupFields({ followups, values, units, labDefs, onValue, onUnit, labels = {} }) {
  const defs = Object.fromEntries((labDefs || []).map((d) => [d.id, d]));
  return (
    <div className="grid grid-cols-1 gap-4 mt-4">
      {followups.map((fu) => {
        const def = defs[fu.id];
        return (
          <div key={fu.id} className="bg-white rounded-lg border border-amber-200 p-3">
            <Label className="text-slate-900 text-sm font-medium flex items-center gap-1.5">
              {def && <FlaskConical className="w-3.5 h-3.5 text-sky-600" />}
              {def ? def.name : labels[fu.id] || fu.label}
            </Label>
            {fu.reason && <p className="text-xs text-slate-500 mt-0.5 leading-relaxed">{fu.reason}</p>}
            {def ? (
              <LabField fu={fu} def={def} value={values[fu.id] || ""} unit={units[fu.id]} onValue={(v) => onValue(fu.id, v)} onUnit={(u) => onUnit(fu.id, u)} />
            ) : fu.type === "select" ? (
              <Select value={values[fu.id] || ""} onValueChange={(v) => onValue(fu.id, v)}>
                <SelectTrigger data-testid={`followup-${fu.id}`} className="mt-2"><SelectValue placeholder={fu.hint || "Select"} /></SelectTrigger>
                <SelectContent>
                  {fu.options.map((o) => <SelectItem key={o.value} value={o.value} data-testid={`followup-${fu.id}-opt-${o.value}`}>{o.label}</SelectItem>)}
                </SelectContent>
              </Select>
            ) : (
              <Input data-testid={`followup-${fu.id}`} type="number" value={values[fu.id] || ""} onChange={(e) => onValue(fu.id, e.target.value)} className="mt-2" placeholder={fu.hint || ""} />
            )}
          </div>
        );
      })}
    </div>
  );
}

export async function downloadBlob(api, path, filename) {
  const res = await api.get(path, { responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([res.data], { type: res.data.type || "application/pdf" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}
